export function getPrevSiblingDistanceToTop(element: HTMLElement | null): number {
  if (!element) {
    return 0;
  }

  /** Находим родительский элемент шапки – это обертка всего контента
   *  Далее находим соседа обертки – это карусель
   *  Возвращаем расстояние расстояние шапки до верха страницы
   **/
  const prevSibling = element.parentElement?.previousSibling as HTMLElement;
  const prevSiblingHeight = prevSibling?.getBoundingClientRect().height || 0;
  const prevSiblingOffsetTop = prevSibling?.offsetTop || 0;

  return prevSiblingHeight + prevSiblingOffsetTop;
}
